import { Component, OnInit } from "@angular/core";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/api";
import { environment } from "../../../../environments/environment";
import { RegisterBookService } from "../../../../app/register-book/service/register-book.service";
import * as fileSaver from "file-saver";
import { DoumentsServiceService } from "./douments-service.service";

@Component({
  selector: "app-documents-popup",
  templateUrl: "./documents-popup.component.html",
  styleUrls: ["./documents-popup.component.scss"],
})
export class DocumentsPopupComponent implements OnInit {
  _data: any;
  apiBaseUrl = environment.API_BASE;
  isPagination: boolean = true;
  _entityName: any;
  letterFlag: boolean = false;
  documents: any;
  _letterData: any;
  _registerBookDocuments: any;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig,
    public registerService: RegisterBookService,
    private service: DoumentsServiceService
  ) {}

  viewfile(doc) {
    let path = "";
    doc.filename.indexOf(this._entityName) > -1
      ? (path = `${this.apiBaseUrl}/file-uploader/downloadS3?path=${doc.filename}`)
      : (path = `${this.apiBaseUrl}/file-uploader/downloadS3?path=gallery/${this._entityName}/${doc.filename}`);
    window.open(path, "_blank");
  }
  getdownloadFile(doc) {
    this.service.getImage(doc).subscribe((res) => {
      var blob = new Blob([res], { type: doc.fileType });
      fileSaver.saveAs(blob, doc.filename);
    });
  }

  getDocument(data) {
    let docId = data.id;
    this.registerService.documentsDataList(docId).subscribe((res: any) => {
      const fileURL = URL.createObjectURL(res);
      window.open(fileURL, "_blank");
    });
  }

  getCreatedDocuments(registerBookId) {
    this.registerService
      .getRegisterBookDocuments(registerBookId)
      .subscribe((res: any) => {
        this._registerBookDocuments = res;
      });
  }

  ngOnInit() {
    this.documents = this.config.data.documents;
    this._data = this.documents.docs;
    this._entityName = this.documents.entityName;
    this._letterData = this.documents.letterData;

    if (this._entityName === "Register-Book") {
      this.letterFlag = true;
      this.getCreatedDocuments(this._letterData[0].id);
    }
  }
  shouldShowViewIcon(fileName: string | undefined): boolean {
    if (!fileName) return false; 
  
    const parts = fileName.split('.');
    const extension = parts.length > 1 ? parts[parts.length - 1].toLowerCase() : '';
  
    console.log("Checking file:", fileName, "Extension:", extension); 
  
    
    return extension === 'pdf' || extension === 'png'  || extension === 'jpg'  || extension === 'jpeg';
  }
  
}
